/** Locale-aware formatting helpers shared by the admin panel. */
const locale = (lng?: string) => (lng === 'en' ? 'en-GB' : 'de-DE');

export const formatDate = (iso: string | null | undefined, lng?: string): string =>
  iso
    ? new Intl.DateTimeFormat(locale(lng), { dateStyle: 'medium' }).format(new Date(iso))
    : '—';

export const formatDateTime = (iso: string | null | undefined, lng?: string): string =>
  iso
    ? new Intl.DateTimeFormat(locale(lng), { dateStyle: 'medium', timeStyle: 'short' }).format(
        new Date(iso),
      )
    : '—';

export const formatNumber = (value: number, lng?: string): string =>
  new Intl.NumberFormat(locale(lng)).format(value);

/** "vor 3 Tagen" / "3 days ago" — relative to now, largest sensible unit. */
export function formatRelative(iso: string, lng?: string): string {
  const diffMs = new Date(iso).getTime() - Date.now();
  const rtf = new Intl.RelativeTimeFormat(locale(lng), { numeric: 'auto' });
  const units: Array<[Intl.RelativeTimeFormatUnit, number]> = [
    ['year', 31_536_000_000],
    ['month', 2_592_000_000],
    ['day', 86_400_000],
    ['hour', 3_600_000],
    ['minute', 60_000],
  ];
  for (const [unit, ms] of units) {
    if (Math.abs(diffMs) >= ms) return rtf.format(Math.round(diffMs / ms), unit);
  }
  return rtf.format(Math.round(diffMs / 1000), 'second');
}
